import { Drawer, Stack, Typography } from '@mui/material'
import { IconButton } from 'utoniq-ui'

import { BrowserLink } from '@/components/lib/BrowserLink'
import { styleSets } from '@/components/styles'
import { useTranslation } from '@/core'
import { getHelpUrl } from '@/lib/helpUrl'

type Props = {
  open: boolean
  name: string
  endAt?: string | null
  deliveryDateText?: string | null
  desc: string
  onClose: () => void
}
/**
 * @description
 * ガチャ説明表示用ドロワー
 */
export const DescriptionDrawer = ({
  open,
  onClose,
  name,
  endAt,
  deliveryDateText,
  desc,
}: Props) => {
  const { t } = useTranslation('gachaDetail')

  return (
    <Drawer open={open} onClose={onClose}>
      <Stack sx={{ p: 5 }} direction="row" alignItems="center">
        <Typography
          variant="h6"
          align="center"
          sx={{ width: '100%', ml: '30px' }}
        >
          {name}
        </Typography>
        <IconButton.Close edge="end" size="small" onClick={onClose} />
      </Stack>
      <Stack spacing={5} sx={{ px: 5, pb: 5, height: 240 }}>
        <Stack sx={{ overflowY: 'scroll', ...styleSets.hideScrollbar() }}>
          {endAt && (
            <Typography variant="overline" sx={{ pb: 1 }}>
              {t('gachaEndAt', { date: endAt })}
            </Typography>
          )}
          {deliveryDateText && (
            <Typography variant="overline" sx={{ pb: 4 }}>
              {t('gachaDeliveryDateText', { date: deliveryDateText })}
            </Typography>
          )}
          <Typography variant="caption">{desc}</Typography>
        </Stack>
        <BrowserLink
          variant="caption"
          width="fit-content"
          href={getHelpUrl('specifiedCommercialTransactionLaw')}
        >
          {t('commercialTransactionLaw')}
        </BrowserLink>
      </Stack>
    </Drawer>
  )
}
